import { renderWithPagination } from '@metorial/data-hooks';
import { Paths } from '@metorial/frontend-config';
import { PageHeader } from '@metorial/layout';
import { useOrganizationMembers } from '@metorial/state';
import { Button, RenderDate } from '@metorial/ui';
import { Table } from '@metorial/ui-product';
import { Link } from 'react-router-dom';
import { Chip, PersonCell, useSettingsScope } from '../_kit';

// Settings › Team › Members (cloud-spec §7.1).
export let OrganizationSettingsMembersPage = () => {
  let scope = useSettingsScope();
  let o = scope.organization;
  let members = useOrganizationMembers(scope.organizationId);

  return (
    <>
      <PageHeader
        title="Members"
        description="People who have access to your organization."
        actions={
          scope.isAdmin && (
            <Link to={`${Paths.organization.invites(o)}?invite=1`}>
              <Button size="2" as="span">
                Invite
              </Button>
            </Link>
          )
        }
      />

      {renderWithPagination(members)(members => (
        <Table
          headers={['Member', 'Status', 'Role', 'Teams', 'Created', '']}
          data={members.data.items.map(member => {
            let teams = member.actor.teams?.length ?? 0;
            let to = Paths.organization.member(o, member.id);

            return {
              href: to,
              data: [
                <PersonCell
                  name={member.actor.name}
                  email={member.actor.email}
                  imageUrl={member.actor.imageUrl}
                />,
                <Chip tone={member.status == 'active' ? 'green' : 'gray'}>
                  {member.status == 'active' ? 'Active' : 'Removed'}
                </Chip>,
                <Chip tone={member.role == 'admin' ? 'purple' : 'gray'}>
                  {member.role == 'admin' ? 'Admin' : 'Member'}
                </Chip>,
                `${teams} ${teams == 1 ? 'team' : 'teams'}`,
                <RenderDate date={member.createdAt} />,
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button size="1" variant="outline" as="span">
                    Open
                  </Button>
                </div>
              ]
            };
          })}
        />
      ))}
    </>
  );
};
